import * as React from 'react';
import { cn } from '@/lib/utils';

const KpiWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-kpi-wrapper', 'flex flex-wrap gap-6', className)}
    {...props}
  />
));
KpiWrapper.displayName = 'KpiWrapper';

const KpiCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-kpi-card',
      // 1. LAYOUT & POSICIONAMENTO
      'relative flex w-[220px] max-w-full flex-grow flex-col items-start',
      // 2. ESPAÇAMENTO (Padding & Gap)
      'gap-2 p-6',
      // 3. VISUAL (Cor, Borda, Arredondamento)
      'rounded-[10px] border border-solid border-gray-200 bg-white',
      // 4. EFEITOS & INTERAÇÃO (Sombra, Transição, Hover)
      'shadow-dropshadow transition-all duration-150 hover:shadow-[0px_4px_20px_rgba(68,43,140,0.25)]',
      className
    )}
    {...props}
  />
));
KpiCard.displayName = 'KpiCard';

const KpiCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-kpi-card-title',
      // 1. LAYOUT & POSICIONAMENTO
      'w-full flex-grow',
      // 2. ESPAÇAMENTO (Padding & Gap)
      'mb-0',
      // 3. TIPOGRAFIA
      'text-base font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
KpiCardTitle.displayName = 'KpiCardTitle';

const KpiCardMetrics = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-kpi-card-metrics', className)}
    {...props}
  />
));
KpiCardMetrics.displayName = 'KpiCardMetrics';

const KpiCardValue = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      // 1. LAYOUT & POSICIONAMENTO
      'w-full flex-shrink-0',
      // 2. ESPAÇAMENTO (Padding & Gap)
      'mb-0',
      // 3. TIPOGRAFIA
      'text-lg font-bold text-primary',
      className
    )}
    {...props}
  />
));
KpiCardValue.displayName = 'KpiCardValue';

const KpiCardMetric = React.forwardRef(({ className, trend, ...props }, ref) => {
  const trendClasses = trend === 'positive' ? 'bg-[#DCFFEA] text-[#1CA388]' : trend === 'negative' ? 'bg-[#facbc8] text-[#8d120a]' : 'bg-primary-lightest text-primary';

  return (
    <div
      ref={ref}
      className={cn(
        // 1. LAYOUT & POSICIONAMENTO
        'w-full rounded-md p-2 px-3',
        // 2. FUNDO E TIPOGRAFIA
        'text-xs',
        trendClasses,
        className
      )}
      {...props}
    />
  );
});
KpiCardMetric.displayName = 'KpiCardMetric';

const KpiCardExplanation = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      // ESPAÇAMENTO (Padding & Gap)
      'mb-0',
      // TIPOGRAFIA
      'text-xs text-neutral-dark',
      className
    )}
    {...props}
  />
));
KpiCardExplanation.displayName = 'KpiCardExplanation';

export { KpiWrapper, KpiCard, KpiCardTitle, KpiCardValue, KpiCardMetrics, KpiCardMetric, KpiCardExplanation };
